const schemasWithoutRelationships = new Set<string>();

export const schemaRelationshipsCacheKey = (schemaName: string, version: string) =>
  `${schemaName}:${version}`;

/** Remember schemas whose relationship catalog/file is absent (BE returns 404). */
export const markSchemaWithoutRelationships = (schemaName: string, version: string): void => {
  schemasWithoutRelationships.add(schemaRelationshipsCacheKey(schemaName, version));
};

/** When false, skip per-record `/relationships` calls — they 404 for the whole schema. */
export const schemaSupportsRelationships = (schemaName: string, version: string): boolean =>
  !schemasWithoutRelationships.has(schemaRelationshipsCacheKey(schemaName, version));
